import React, { useEffect, useState } from 'react'
import { ReactDatePicker } from 'sr/helpers/ui-components/ReactDatePicker'
import { FormattedMessage } from 'react-intl'
import { toast } from 'react-toastify'
import moment from 'moment'
export const HireTimelineChange = (props) => {
  const [timeline, setTimeline] = useState(new Date())

    const applicationDeadline =
    props?.data?.job_advanced_id?.application_deadline
      ? new Date(props?.data?.job_advanced_id?.application_deadline)
      : null;


  useEffect(()=> {
    const recruitmentTimeline =
    props?.data?.job_advanced_id?.recruitment_timeline;
    if (recruitmentTimeline) {
      const newdate = new Date(recruitmentTimeline);
      setTimeline(newdate);
    }
  },[props?.data])

  useEffect(()=> {
    const data = {
      recruitment_timeline:timeline
    }
    props?.HandleDataProps(data)
  },[timeline])

  const startDate = props?.data?.start_date;

  const handleChange = (date) => {
    if (applicationDeadline) {
      const pickDate = moment(date).startOf('day');
      const deadLine = moment(applicationDeadline).startOf('day');

      if (pickDate.isBefore(deadLine)) {
        toast.error('Hiring timeline cannot be before the application deadline.');
        return;
      }
    }
    setTimeline(date);
  };

  return (
    <>
    <ReactDatePicker 
InputDivClass="mt-2"
// onChange={(date)=> setTimeline(date)}
onChange={handleChange}
selected={timeline}
minDate={startDate ? new Date(startDate): new Date()}
inputClass="bg-white border border-zinc-800 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-blue-500 focus:border-[#0078ae] focus:shadow-[0_3px_0px_0px_rgb(37,87,167)] block w-full pl-10 p-2 uppercase"
label={<FormattedMessage id="RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.RECRUITMENTTIMELINE.TITLE" defaultMessage="Position needs filled by" />}>
</ReactDatePicker>
</>
  )
}
